export const ROUTE_MAINPAGE = '/'

export const ROUTE_OWNINFO = '/owninfo'

export const OWNINFO_TAB_BASEDETAILS = 'base-details'
export const OWNINFO_TAB_MEMBERSHIP = 'membership'
export const OWNINFO_TAB_EMPLOYMENT = 'employment'
export const OWNINFO_TAB_ASSIGNMENTS = 'assignments'

const createTabRoute = (pageRoute: string, tab: string) => {
  return pageRoute + '/' + tab
}

export const createOwnInfoRoute = (tab: string) => {
  return createTabRoute(ROUTE_OWNINFO, tab)
}

export const ROUTE_OWNINFO_BASEDETAILS = createOwnInfoRoute(
  OWNINFO_TAB_BASEDETAILS
)
export const ROUTE_OWNINFO_MEMBERSHIP = createOwnInfoRoute(
  OWNINFO_TAB_MEMBERSHIP
)
export const ROUTE_OWNINFO_EMPLOYMENT = createOwnInfoRoute(
  OWNINFO_TAB_EMPLOYMENT
)
export const ROUTE_OWNINFO_ASSIGNMENTS = createOwnInfoRoute(
  OWNINFO_TAB_ASSIGNMENTS
)

export const ROUTE_MEMBERSHIP_FEES = '/membership-fees'

export const ROUTE_ADD_PAYMENT_EXEMPTION = '/add-payment-exemption'
export const ROUTE_CALCULATE_MEMBERSHIP_FEE = '/calculate-membership-fee'

export const ROUTE_MESSAGES = '/messages'

export const MESSAGES_TAB_EMAILS_AND_SMS = 'emails-and-sms'
export const MESSAGES_TAB_LETTERS = 'letters'
export const MESSAGES_TAB_NEWS = 'news'

const createMessagesRoute = (tab: string) => {
  return createTabRoute(ROUTE_MESSAGES, tab)
}

export const ROUTE_MESSAGES_EMAILS_AND_SMS = createMessagesRoute(
  MESSAGES_TAB_EMAILS_AND_SMS
)
export const ROUTE_MESSAGES_LETTERS = createMessagesRoute(MESSAGES_TAB_LETTERS)
export const ROUTE_MESSAGES_NEWS = createMessagesRoute(MESSAGES_TAB_NEWS)

export const ROUTE_VERSION_INFO = '/version'
